<template>
  <div>
    <!-- 创建账号 -->
    <FileUpload
      ref="fileUpload"
      title="批量创建渠道账号"
      style-type="dragger"
      temp-file-name="批量创建渠道账号模板"
      temp-key="create-channel-account"
      upload-url="/unioncenter/auth/storeChannelSalesman/import-to-create-channel-account"
      error-url="errorUrl"
      :max-file-count="300"
      :max-file-size="20"
      :footer="true"
      :footer-ops="footerOps"
      :footer-custom="true"
      :visible.sync="channelVisible"
      @handleOk="handleOk"
      @close="handleClose"
    >
      <div
        class="role-select"
        slot="content"
      >
        <GroupTitle title="角色选择"/>
        <a-select
          style="width: 280px"
          placeholder="请选择角色"
          v-model="currentRole"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, idx) in roleList"
            :key="idx"
          >{{ item.roleName }}</a-select-option>
        </a-select>
      </div>
    </FileUpload>
    <!-- 处理创建后的结果 -->
    <a-modal
      class="export-modal"
      :visible="resultVisible"
      :keyboard="false"
      :mask-closable="false"
      title="批量创建渠道账号"
      :width="600"
      :destroy-on-close="true"
      @cancel="handleCancel"
      @ok="handleResultOk"
    >
      <div class="result-content">
        <img src="http://hh-oss-picture.miyapay.com/box/3d4dc3bae1dc571c1028fbc149eaeb8f.svg">
        <div class="result-text">创建完成</div>
        <div class="result-btns">
          <a-button @click="handleExport">导出账号</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import FileUpload from '@/components/upload/FileUpload';
import GroupTitle from '@/components/group-title';
import { fetchList } from '@/apis/role';
import { apiBatchCreateChannel, apiExportAccount } from '@/apis/account';

export default {
  name: 'ChannelBatchCreate',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FileUpload,
    GroupTitle,
  },
  data() {
    return {
      roleList: [], // 角色列表
      currentRole: undefined, // 当前选择的角色
      channelVisible: false, //
      footerOps: { // footer按钮文案
        cancelText: '取消',
        okText: '创建',
      },
      resultVisible: false, // 是否显示结果弹窗
      resultList: [], // 创建完成后的列表
    };
  },
  watch: {
    visible(val) {
      this.channelVisible = val;
      if (val) {
        this.getRoleList();
      }
    },
    channelVisible(val) {
      if (!val) {
        this.$emit('update:visible', false);
      }
    },
  },
  methods: {
    // 关闭上传modal
    handleClose() {
      this.currentRole = undefined;
    },
    // 点击创建
    handleOk(result) {
      const { toCreateChannelAccountFormList } = result;
      if (!toCreateChannelAccountFormList) {
        this.$message.warning('请先上传文件');
        return;
      }
      if (!this.currentRole) {
        this.$message.warning('请选择角色');
        return;
      }
      const roleVO = this.roleList.find(item => item.id === this.currentRole);
      apiBatchCreateChannel({
        roleVO,
        salesmanDTOList: toCreateChannelAccountFormList,
      }).then((res) => {
        this.$refs.fileUpload.reset();
        this.resultList = res;
        this.channelVisible = false;
        this.currentRole = undefined;
        this.resultVisible = true;
      });
    },
    // 导出账号
    handleExport() {
      apiExportAccount(this.resultList).then((res) => {
        this.resultVisible = false;
        window.location.href = res;
      });
    },
    // 获取角色列表
    getRoleList() {
      fetchList().then((res) => {
        this.roleList = res;
      });
    },
    // 点击确认
    handleResultOk() {
      this.handleCancel();
    },
    // 点击关闭
    handleCancel() {
      this.resultVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.result-content {
  text-align: center;
}
.result-text {
  margin-top: 40px;
  margin-bottom: 42px;
}
.export-modal /deep/.antmain-modal-footer .antmain-btn:nth-child(1) {
  display: none;
}
</style>
